export enum FinancialInformationEnum {
  Todos = 'Todos',
  EmAberto = 'Em Aberto',
  Baixados = 'Baixados',
}
